import axios from 'axios';

import querystring from 'querystring';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveAllUsers(context, data = {}) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const users = await axios.get(`/autodesk/bim-360/account-admin/account-user?${data.query ? querystring.stringify(data.query) : ''}`, config);
        return users.data;
      } catch (error) {
        throw error;
      }
    },
    async searchUsers(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const users = await axios.get(`/autodesk/bim-360/account-admin/account-user/search?${data.query ? querystring.stringify(data.query) : ''}`, config);
        return users.data;
      } catch (error) {
        throw error;
      }
    },
    async updateAccountUser(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const users = await axios.patch(`/autodesk/bim-360/account-admin/account-user/${data.userId}`, data.payload, config);
        return users.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
